import Section from "../../components/Common/Section";
import Heading from "../../components/Common/Heading";
import Divider from "../../components/Common/Divider";
import ApiStatus from "../../components/ApiStatus";
import { useFetchIzobrazevanjeJavnoAll } from "./IzobrazevanjeHooks";
import IzobrazevanjeListTableFiltri from "./IzobrazevanjeListTableFiltri";
import { IzobrazevanjeVrsta } from "../../utils/Enums";

const IzobrazevanjeJavnoList = () => {

    const { data, status, isSuccess } = useFetchIzobrazevanjeJavnoAll();

    if (!isSuccess)
        return (
            <Section>
                <Heading>Pregled Javnih objav
                    <Divider />
                </Heading>
                <ApiStatus status={status}></ApiStatus>
            </Section>
        )

    return (
        <Section>
            <Heading>
                Pregled javnih objav
                <Divider />
            </Heading>
            <IzobrazevanjeListTableFiltri                
                izobrazevanjeListData={data}
                izobrazevanjeVrsta={IzobrazevanjeVrsta.Javno}
            />
        </Section>
    );
}

export default IzobrazevanjeJavnoList;
